    // src/App.js
    import React from 'react';
    import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
    import Navbar from './components/Navbar';
    import HomePage from './components/HomePage';
    import AboutPage from './components/AboutPage';
    import './App.css'; // Optional: for global styling
    import ContactPage from './components/ContactPage';
    import ResourcesPage from './components/ResourcesPage';

    function App() {
      return (
        <Router>
          <div className="App">
            <div className="logo">
                <img src="/images/logo-green.png" alt="Etaswa Logo" />
            </div>
            <Navbar />
            <div className="content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                {/* <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} /> */}
              </Routes>
            </div>
          </div>
        </Router>
      );
    }

    export default App;